export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-06_DE.07664c14.png";